import Paths from '../paths';
import Pages from '../pages';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom';
import { updateSignupPage } from '../actions';

const Redirector = ({ page, this_page }) => {
  const redirect = (page !== this_page)
  const enable_firebase_authentication = useSelector(state => state.territory.enable_firebase_authentication)

  useEffect(() => {
    if (redirect) {
      updateSignupPage(page);
    }
  }, [redirect, page]);

  const redirectPath = () => {
    switch(page){
      case Pages.ARRIVAL_PAGE : return Paths.ARRIVAL_PATH;
      case Pages.COMPLETE_PAGE : return Paths.COMPLETE_PATH;
      case Pages.EDUCATION_PAGE : return Paths.EDUCATION_PATH;
      case Pages.GUARDIAN_EMERGENCY_PAGE : return Paths.GUARDIAN_EMERGENCY_PATH;
      case Pages.PERSONALITY_PROFILE_PAGE : return Paths.PERSONALITY_PROFILE_PATH;
      case Pages.LANGUAGE_NATIONALITY_PAGE : return Paths.LANGUAGE_NATIONALITY_PATH;
      case Pages.MEDICAL_PAGE : return Paths.MEDICAL_PATH;
      case Pages.PETS_CHILDREN_PAGE : return Paths.PETS_CHILDREN_PATH;
      case Pages.PLACEMENT_PAGE : return Paths.PLACEMENT_PATH;
      case Pages.PRODUCT_PAGE : return Paths.PRODUCT_PATH;
      case Pages.REGISTER_PAGE : return Paths.REGISTER_PATH;
      case Pages.RETURN_LATER_PAGE : return Paths.RETURN_LATER_PATH;
      case Pages.ADDRESS_PAGE : return Paths.ADDRESS_PATH;
      case Pages.DEPARTURE_PAGE : return Paths.DEPARTURE_PATH;
      case Pages.FIREBASE_REGISTER_FORM_PAGE : return Paths.FIREBASE_REGISTER_PATH;
      case Pages.FIREBASE_ACCOUNT_DETAILS_FORM_PAGE : return Paths.FIREBASE_ACCOUNT_DETAILS_PATH;
      default: return enable_firebase_authentication ? Paths.FIREBASE_REGISTER_PATH : Paths.REGISTER_PATH;
    }
  }

  if (redirect) {
    return <Redirect to={redirectPath()}/>;
  } else {
    return null;
  }
}

export default Redirector
